import { useSelect } from '@mui/base/useSelect';
import { useRef, useEffect } from 'react';
import { isEnterKey, isSpaceKey } from '../../../utils/keyboard.js';
import { useActive } from '../../../utils/useActive/useActive.js';
import { useGetYearsOptions } from './useGetYearsOptions.js';

function useYearPicker({ monthDate, yearsOffset, onChangeYear }) {
    const { isActive: isOpenDropdown, toggleActive, deactivate } = useActive();
    const { yearsOptions } = useGetYearsOptions({ offset: yearsOffset });
    const currentYear = monthDate.getFullYear();
    const listboxRef = useRef(null);
    const targetItemRef = useRef(null);
    const { getListboxProps } = useSelect({ listboxRef, options: yearsOptions });
    // Scroll to current year once dropdown is opened
    useEffect(() => {
        if (isOpenDropdown && listboxRef.current && targetItemRef.current) {
            const dropdown = listboxRef.current;
            const targetItem = targetItemRef.current;
            const offset = dropdown.offsetTop * 3;
            const scrollPosition = targetItem.offsetTop - offset;
            dropdown.scrollTop = scrollPosition;
            targetItem.focus();
        }
    }, [isOpenDropdown]);
    const handleYearClick = (year) => () => {
        onChangeYear(year);
        deactivate();
    };
    const handleKeyDown = (year) => (event) => {
        if (isEnterKey(event) || isSpaceKey(event)) {
            handleYearClick(year)();
        }
    };
    const handleFocusLeavingList = (event) => {
        // Check if the focus is moving to an element outside the list
        if (!event.currentTarget.contains(event.relatedTarget)) {
            deactivate();
        }
    };
    return {
        toggleActive,
        deactivate,
        handleKeyDown,
        handleFocusLeavingList,
        handleYearClick,
        isOpenDropdown,
        currentYear,
        getListboxProps,
        yearsOptions,
        targetItemRef,
    };
}

export { useYearPicker };
//# sourceMappingURL=useYearPicker.js.map
